import type { UserRepository } from '../repositories/user-repository';

export class DeleteUserUseCase {
  constructor(private readonly repository: UserRepository) {}

  async execute(id: string): Promise<void> {
    return this.repository.delete(id);
  }
}
